import { createFileRoute } from '@tanstack/react-router';
import { AdminProfilePage } from '../../features/directory';

export const Route = createFileRoute('/admin/directory/profiles/$orgId')({
  component: function AdminProfileRoute() {
    const { orgId } = Route.useParams();
    return <AdminProfilePage orgId={orgId} />;
  },
});
